<template>
  <div class="Rank">
    <logo :logo="logo" class="logo"></logo>
    <div class="group">
      <div class="grp fs20" :class="{focus: fcg==g.key }" v-for="g in groups" @click="focus(g.key)">{{g.text}}</div>
    </div>
    <my_table :infos="info" :titles="titles"></my_table>
  </div>
</template>

<script>
 import MyTable from '@/components/Table.vue'
  import Logo from '@/components/Logo.vue'
 export default {
   name: 'Rank',
   computed: {
     user() {
       return this.$store.state.auth.user
     },
      logo() {
        return this.$store.state.logo.mainBlack
      },
     groups() {
       return this.$store.state.enroll.groups
     },
     titles() {
       return this.$store.state.score.rank.title
     },
     infos () {
       return this.$store.state.score.rank.infos
     },
     indexOfGroup() {
       return {
         's': 1,
         'm': 2,
         'l': 3
       }
     }
   },
   data() {
     return {
       fcg: 's',
       info: []
     }
   },
   methods: {
     nav(game){
         if(game)
         {
             window.open(this.$store.state.gamelink+this.$store.state.auth.token.token, "_blank")
         }
       else{
         this.$router.replace({name:'rank', params:{me: true}})
       }

     },
     fetchData () {
       let round = this.$store.state.game_year + '-1';
       let group =  this.indexOfGroup[this.fcg];
       let uri = '/api/rank?round='+round+'&group='+group;
       this.$http.get(uri)
           .then(res => {
             this.info = res.data.map(d=>
             {return [d.rank, d.username, d.score, d.area_name]})
           })
     },
     focus(k) {
       this.fcg = k
       this.fetchData()
     }
   },
   mounted() {
     this.fetchData()
   },
   components: {
     my_table: MyTable,
      logo: Logo,
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Rank{
   display: flex;
   justify-content: center;
   align-items: center;
   flex-direction: column;
   margin-top: 5vw;
   margin-bottom: 3.4vw;
 }
 .group{
   display: flex;
   align-items:center;
   justify-content: space-around;
   width: 90vw;
   margin-top: 5vw;
   border-bottom: 1px dashed black;
   margin-bottom: 1.5625vw;
 }
 .grp{
   line-height: 25px;
   flex:1;
   text-align: center;
 }
 .focus{
   border-bottom: 1px solid black;
   color: #4411FF;
 }
</style>
